// @flow
import type { RegistrationState } from './index'
import {
  SET_EMAIL_ADDRESS, SET_REGISTRATION_VALIDATION_SUCCESS, SET_REGISTRATION_VALIDATION_ERRORS, RESET
} from './mutation-types'
import type { PropertyError } from '../../../types/validation-result'
import { REGISTRATION_STATUS_ERROR, REGISTRATION_STATUS_SUCCESS, REGISTRATION_STATUS_NOT_REGISTRERED } from './index'

export default {
  [SET_EMAIL_ADDRESS]: (state: RegistrationState, emailAddress: string) => {
    state.emailAddress = emailAddress
  },
  [SET_REGISTRATION_VALIDATION_ERRORS]: (state: RegistrationState, errors: PropertyError[]) => {
    if (errors.length > 0) {
      state.status = REGISTRATION_STATUS_ERROR
    }
    state.registrationValidationErrors = errors
  },
  [SET_REGISTRATION_VALIDATION_SUCCESS]: (state: RegistrationState) => {
    state.status = REGISTRATION_STATUS_SUCCESS
    state.registrationValidationErrors = []
  },
  [RESET]: (state: RegistrationState) => {
    state.status = REGISTRATION_STATUS_NOT_REGISTRERED
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/registration/mutations.js